import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../helpers/visibility'

export default class extends Controller {
  static targets = ["checkbox", "invoiceIdField", "bulkUpdateControls"]

  connect() {
    this.update()
  }

  update() {
    if(this.hasInvoiceIdFieldTarget) {
      const checked = this.checkboxTargets.filter(c => c.checked)
      const invoiceIds = checked.map(checkbox => checkbox.value)
      this.invoiceIdFieldTargets.forEach(target => {
        target.value = invoiceIds.join(",")
      })

      if(invoiceIds.length) {
        showTarget(this.bulkUpdateControlsTarget)
      }
      else {
        hideTarget(this.bulkUpdateControlsTarget)
      }
    }
    else {
      this.hideAllCheckboxes()
    }
  }

  hideAllCheckboxes() {
    hideTarget(this.checkboxTargets)
  }
}

